import request from './.request'

export function listEnterprises(pageNum, pageSize) {
  return request({
    url: 'enterprise',
    method: 'get'
  })
}
/**
 * 根据人员id查询其所任职的所有公司，得到列表
 * @param {Number} usrId 人员id，当前用户的id可在vue上下文中得到
 * @returns
 */
export function listMyEnterprises(personId) {
  return request({
    url: `enterprise/${personId}?by=person`, //必须提供by=person参数，无此参数则personId会被视作公司id
    method: 'get'
  })
}

/*
* 主题管理
* */
export function enterpriseSearch(e) {
  return request({
    url: `/enterprise`,
    method: 'get',
    params:e
  })
}
export function enterpriseAdd(e) {
  return request({
    url: `/enterprise`,
    method: 'post',
    data:e
  })
}
export function enterpriseUpdate(e) {
  return request({
    url: `/enterprise`,
    method: 'put',
    data:e
  })
}

export function addEnterprise(e) {
  return request({
    url: '/enterpriseManager/insertEnterpriseInfo',
    method: 'post',
    data: e
  })
}

export function enterpriseUpload(id,e) {
  return request({
    url: `/upload/enterprise/${id}/facade`,
    method: 'post',
    data:e
  })

}
export function uploadPhotos(id,e) {
  return request({
    url: `/upload/enterprise/${id}/honor`,
    method: 'post',
    data:e
  })
}

export function getHonorsByEnterpriseId(id) {
  return request({
    url: `/upload/${id}`,
    method: 'get',

  })
}
export function enterpriseDetail(id) {
  return request({
    url: `/enterprise/${id}`,
    method: 'get',

  })
}

export function photoDelete(id,url) {
  return request({
    url: `/enterprise/${id}?of=honors`,
    method: 'delete',
    params:{
      picPath:url
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/enterprise.js